import * as Yup from 'yup'

export const leadAdValidationRules = Yup.object().shape({
  name: Yup.string().required('name is required'),
});